import { jsPDF } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// Apply the autoTable plugin to jsPDF
applyPlugin(jsPDF);

export const exportToPDF = (title, subtitle, columns, rows, fileName) => {
  const doc = new jsPDF('landscape');

  // Header bar
  doc.setFillColor(21, 106, 202);
  doc.rect(0, 0, 297, 28, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('Premier Carbonic', 14, 12);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.text(title, 14, 20);

  // Subtitle
  doc.setTextColor(80, 80, 80);
  doc.setFontSize(10);
  doc.text(subtitle, 14, 36);

  // Table
  doc.autoTable({
    startY: 42,
    head: [columns],
    body: rows,
    theme: 'grid',
    headStyles: {
      fillColor: [21, 106, 202],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      fontSize: 9,
    },
    bodyStyles: { fontSize: 9 },
    alternateRowStyles: { fillColor: [232, 242, 252] },
    styles: { cellPadding: 3 },
    margin: { left: 14, right: 14 },
  });

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text(
      `Generated: ${new Date().toLocaleDateString('en-IN')} | Page ${i} of ${pageCount}`,
      14,
      doc.internal.pageSize.height - 10
    );
  }

  doc.save(`${fileName}.pdf`);
};

export const exportToExcel = (title, columns, rows, fileName) => {
  const wsData = [
    ['Premier Carbonic - Production Management System'],
    [title],
    [],
    columns,
    ...rows
  ];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Column widths
  ws['!cols'] = columns.map(() => ({ wch: 18 }));

  // Merge header row
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: columns.length - 1 } }
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(data, `${fileName}.xlsx`);
};
